import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Orders from "../../order/orders/orders.jsx";
const Coin_home = () => {
    const { slug_1 } = useParams();
    return (
        <>
            <Orders />
        </>
    );
}

export default Coin_home;
